// import
import gsap from "gsap";

export function JobOpening() {
  gsap
    .timeline()
    .add(
      () =>
        document
          .querySelectorAll(".js-fv-target")
          .forEach((el) => el.classList.add("is-active")),
      "+=0.3",
    )
    .add(
      () =>
        document
          .querySelectorAll(".js-title-target")
          .forEach((el) => el.classList.add("is-start")),

      "+=0.2",
    )
    .add(
      () =>
        document
          .querySelectorAll(".js-title-target")
          .forEach((el) => el.classList.add("is-active")),

      "+=0.6",
    );
}
